import type { FC, PropsWithChildren } from "react";
import { Children, useEffect, useState } from "react";

import { Column, Row } from "@jti/core-components/components/Row";

import type { CarouselProps } from "../Carousel";
import { Carousel } from "../Carousel";
import type { ContainerHeaderProps } from "../ContainerHeader";
import { ContainerHeader } from "../ContainerHeader";
import { ProductCardContainerContextProvider } from "../ProductCardContainerContextProvider/ProductCardContainerContextProvider";

import { ProductCardContainerViewItemListEventDispatcher } from "./ProductCardContainerViewItemListEventDispatcher";

import styles from "./ProductCardContainer.module.scss";

export type ProductCardContainerProps = {
  isCarousel?: boolean;
  isTrial?: boolean;
  isViewItemListEventEnabled?: boolean;
} & CarouselProps &
  ContainerHeaderProps;

export const ProductCardContainer: FC<PropsWithChildren<ProductCardContainerProps>> = ({
  children,
  isCarousel,
  title,
  ctaHref,
  ctaLabel,
  desktopItemCount = 3,
  tabletItemCount = 2,
  isTrial = false,
  isControlHidden = false,
  isViewItemListEventEnabled = false,
}) => {
  const [showLoader, setShowLoader] = useState(true);
  const expectedItemsCount = Children.toArray(children).length;

  useEffect(() => {
    setShowLoader(false);
  }, []);

  return (
    <ProductCardContainerContextProvider isTrial={isTrial}>
      <div className={styles.content}>
        <ProductCardContainerViewItemListEventDispatcher
          isEnabled={isViewItemListEventEnabled}
          expectedItemsCount={expectedItemsCount}
        />
        <ContainerHeader title={title} ctaHref={ctaHref} ctaLabel={ctaLabel} />
        {isCarousel ? (
          <Carousel
            tabletItemCount={tabletItemCount}
            desktopItemCount={desktopItemCount}
            isControlHidden={isControlHidden}
            withoutSlidesMinHeight
            showLoader={showLoader}
          >
            {children}
          </Carousel>
        ) : (
          <Row>
            {Children.map(children, (child) => (
              <Column sm={12} md={12} lg={4}>
                {child}
              </Column>
            ))}
          </Row>
        )}
      </div>
    </ProductCardContainerContextProvider>
  );
};
